/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-11-23 17:25:26
 * @LastEditors: voanit
 * @LastEditTime: 2022-11-29 15:57:04
 */
import router from './router'
import store from '@/store'
import { Message, MessageBox } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, getUserRoles } from '@/utils/auth' // getToken from cookie
import defaultSettings from '@/settings'
import { globalDictLists } from '@/utils/datalistCommon.js'
let globalDictNum = 0
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/questionPage', '/questionPageDetail', '/questionPagePaging'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  // document.title = getPageTitle(to.meta.title)
  document.title = defaultSettings.title

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken && getUserRoles()) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      console.log(store.getters.addRoutes, 'store.getters.addRoutes')
      const hasAddRoutes = store.getters.addRoutes && store.getters.addRoutes.length > 0
      //获取全局设置
      if (globalDictNum === 0) {
        globalDictLists()
        globalDictNum++
      }
      if (hasAddRoutes) {
        next()
      } else {
        if (!store.getters.roles) {
          await store.dispatch('getUserPermissions')
        } else if (store.getters.roles.length === 0) {
          await store.dispatch('FedLogOut')
          Message.error('此账号未分配权限，请联系相关人员添加！')
          NProgress.done()
        }
        try {
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('generateRoutes', store.getters.roles)

          await store.dispatch('getGlobalTodo')
          await store.commit(
            'setTodoPolling',
            setInterval(() => {
              store.dispatch('getGlobalTodo')
            }, 60 * 1000 * 1)
          )
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('FedLogOut')
          Message.error(error || 'Has Error')
          // next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      const redirectQuery = Object.keys(to.query).reduce((query, key) => {
        if (key !== 'redirect') {
          query[key] = to.query[key]
        }
        return query
      }, {})
      const queryString = Object.keys(redirectQuery).length > 0 
        ? '&' + Object.entries(redirectQuery).map(([key, value]) => `${key}=${value}`).join('&')
        : ''
      next(`/login?redirect=${to.path}${queryString}`)
      NProgress.done()
    }
  }
})
router.onError(error => {
  console.log('版本更新：', error.message)
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  // const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    window.location.reload()
    // router.replace(targetPath)
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
